import { escape } from "../utils/dom";
export default (function (data) {
  return "<a href=\"javascript:void(0);\" class=\"dropdown-item\" data-value=\"".concat(escape(data.value), "\" data-text=\"").concat(escape(data.text), "\">").concat(escape(data.text), "</a>");
});